import { forwardRef } from "react";
import { SVGFillPath, SVGIconRoot } from "./SVGComponents";
import { IconProps } from "./index";

export const Triangle = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <SVGIconRoot viewBox="0 0 13 10" ref={ref} {...props}>
      <SVGFillPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.66156 8.71009C6.0559 9.31677 6.9441 9.31677 7.33844 8.71009L13 0H0L5.66156 8.71009Z"
      />
    </SVGIconRoot>
  );
});
